import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const whitelist = [
  "/components/pricelist-subscription/PriceListShoppingCart",
];

type timerProps = {
  delayMinutes: number;
};

export const IdleTimer = ({ delayMinutes }: timerProps) => {
  const location = useLocation();
  let timeout: NodeJS.Timeout | null = null;

  const goBackToHome = () => {
    console.log('TO|RF');
    window.location.reload();
  };

  const restartAutoReset = () => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      goBackToHome();
    }, delayMinutes * 1000 * 60);
  };

  const _onMouseMove = () => {
    restartAutoReset();
  };

  useEffect(() => {
    // Whitelist certain pages
    let preventReset = false;
    for (const path of whitelist) {
      if (path === location.pathname) {
        preventReset = true;
      }
    }
    if (preventReset) {
      return;
    }

    // initiate timeout
    restartAutoReset();

    // listen for mouse events
    window.addEventListener("mousemove", _onMouseMove);

    // cleanup
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        window.removeEventListener("mousemove", _onMouseMove);
      }
    };
  }, [location.pathname]);
  return <div />;
};
